import { useState } from 'react';
import { LocalizedText, lt } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { TableBulkActions, TableBulkActionButton } from '@optimus-web/core';
import { IconName } from '@optimus-web/icons';
import { DeleteRatesDialog } from './DeleteRatesDialog';

interface BulkActionProps {
    selectedRowsIds: string[];
    hasRowsSelected: boolean;
    resetRowSelection: () => void;
}

export const BulkActions = ({ selectedRowsIds, hasRowsSelected, resetRowSelection }: BulkActionProps) => {
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    return (
        <TableBulkActions
            disabled={!hasRowsSelected}
            leftSide={
                hasRowsSelected ? (
                    <LocalizedText textKey={TextKey.SelectedItems} substitutes={{ count: selectedRowsIds.length }} />
                ) : null
            }
            rightSide={
                <>
                    <TableBulkActionButton
                        icon={IconName.Delete}
                        disabled={!hasRowsSelected}
                        onClick={() => setIsDialogOpen(true)}
                    >
                        {lt('Delete')}
                    </TableBulkActionButton>
                    <DeleteRatesDialog
                        rateIds={selectedRowsIds}
                        onClose={() => setIsDialogOpen(false)}
                        onDeleteSuccess={resetRowSelection}
                        active={isDialogOpen}
                    />
                </>
            }
        />
    );
};
